export default __webpack_public_path__ + "static/main_copy-01-f03b418287d652ae543cc5622cffe4b3.svg";